<template>
  <PageTemplate>
    <v-breadcrumbs
      :breadcrumbs="breadcrumbs"
    />
    <h1>Jobs</h1>
    <v-card title="Jobs">
      <v-table
        v-show="checkAR"
        :table="AR_table"
      />
      <v-table
        v-show="!checkAR"
        :table="TA_table"
      />
    </v-card>
  </PageTemplate>
</template>

<script>
  import PageTemplate from "../templates/Page/index.vue";
  import Breadcrumbs from "@/molecules/Breadcrumbs";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import flatPicker from "flatpickr";
  import "flatpickr/dist/flatpickr.css";
  import "flatpickr/dist/themes/airbnb.css";
  import {columnFilter, columnSort, dateSort_ddmmyy, buildBreadCrumb} from "../common/tableFunctions";
  import {GET_USER_JOBS} from "../store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";

  export default {
    name: "Jobs",
    components: {
      "v-table": Table,
      "v-breadcrumbs": Breadcrumbs,
      "v-card": Card,
      PageTemplate,
    },
    data() {
      return {
        checkAR: false,
        components: {
          flatPicker
        },
        TA_table: {
          columns: [
            {
              label: 'Job ID',
              field: 'job_number',
              link: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Job ID',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Job Type',
              field: 'type',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['RES', 'Other'],
                filterFn: columnFilter
              },
            },
            {
              label: 'Visit Date',
              field: 'visit_date',
              sortFn: dateSort_ddmmyy,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Date',
                filterFn: columnFilter
              },
            },
            {
              label: 'Facility Name',
              field: 'facility',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Fac. Name',
                filterFn: columnFilter
              },
            },
            {
              label: 'Facility ID',
              field: 'facility_id',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Fac. ID',
                filterFn: columnFilter
              },
            },
            {
              label: 'Site Name',
              field: 'site',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Site Name',
                filterFn: columnFilter
              },
            },
            {
              label: 'Site ID',
              field: 'site_id',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Site ID',
                filterFn: columnFilter
              }
            },
            {
              label: 'Suburb',
              field: 'suburb',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['All'],
                filterFn: columnFilter
              }
            },
            {
              label: 'State',
              field: 'state',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['All'],
                filterFn: columnFilter
              }
            },
            {
              label: 'Status',
              field: 'status',
              badge: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['All'],
                filterFn: columnFilter
              },
            },
            {
              label: 'Stage',
              field: 'stage',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['All'],
                filterFn: columnFilter
              }
            },
          ],
          rows: [],
          totalRecords: 0,
          initialRowsPerPage: 10
        },
        AR_table: {
          columns: [
            {
              label: 'Job ID',
              field: 'job_number',
              link: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Job ID',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Job Type',
              field: 'type',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['RES', 'Other'],
                filterFn: columnFilter
              },
            },
            {
              label: 'Status',
              field: 'status',
              badge: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: ['In progress', 'Planned'],
                filterFn: columnFilter
              },
            },
            {
              label: 'Visit Date',
              field: 'visit_date',
              sortFn: dateSort_ddmmyy,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Date',
                filterFn: columnFilter
              },
            },
            {
              label: 'Facility',
              field: 'facility',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Fac. Name',
                filterFn: columnFilter
              },
            },
            {
              label: 'Facility ID',
              field: 'facility_id',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Fac. ID',
                filterFn: columnFilter
              },
            },
            {
              label: 'Site',
              field: 'site',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Site Name',
                filterFn: columnFilter
              },
            },
            {
              label: 'Site ID',
              field: 'site_id',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Site ID',
                filterFn: columnFilter
              }
            }
          ],
          rows: [],
          totalRecords: 0,
          initialRowsPerPage: 10
        },
        breadcrumbs: [],
      };
    },
    mounted() {
      this.getUserJobs();
      let inputs = [
        'input[placeholder="Date"]',
      ];
      inputs.forEach(function (input) {
        flatPicker(input, {
          dateFormat: "d/m/y",
          allowInput: true,
          theme: "light"
        });
      });
      this.updateBreadCrumb();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Jobs'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getUserJobs() {
        this.$store.dispatch(GET_USER_JOBS).then(response => {
          let list = response.data;
          //if auth.state is not yet ready, watch the value change.
          if (!this.$store.state.auth.permissions) {
            this.$store.watch(
              (state) => state.auth.permissions,
              (value) => {
                if (value) {
                  this.updateJobs(value, list);
                }
              }
            )
          } else {
            this.updateJobs(this.$store.state.auth.permissions, list)
          }
        });
      },
      updateJobs(permissions, list) {
        if (permissions.indexOf(constants.NATA_ROLE_AR) !== -1) {
          this.checkAR = true;
          this.AR_table.rows = list;
          this.updateDropDownFilters(constants.NATA_ROLE_AR);
        } else if (permissions.indexOf(constants.NATA_ROLE_TA) !== -1 || permissions.indexOf(constants.NATA_ROLE_LA) !== -1) {
          this.checkAR = false;
          this.TA_table.rows = list;
          this.updateDropDownFilters(constants.NATA_ROLE_TA);
        }
      },
      updateDropDownFilters(role) {

        //set dynamically changed for dropdown filters for job-type, status,
        if (role === constants.NATA_ROLE_TA || role === constants.NATA_ROLE_LA) {
          const jobType = this.TA_table.rows.map(i => i.type.value);
          const jobStatus = this.TA_table.rows.map(i => i.status.value);
          const suburb = this.TA_table.rows.map(i => i.suburb.value);
          const state = this.TA_table.rows.map(i => i.state.value);
          const stage = this.TA_table.rows.map(i => i.stage.value);
          this.TA_table.columns[1].filterOptions.filterDropdownItems = Array.from([...new Set(jobType.filter(
            function (el) {
              return el != null;
            }
          ))]);
          this.TA_table.columns[7].filterOptions.filterDropdownItems = Array.from([...new Set(suburb.filter(
            function (el) {
              return el != null;
            }
          ))]);
          this.TA_table.columns[8].filterOptions.filterDropdownItems = Array.from([...new Set(state.filter(
            function (el) {
              return el != null;
            }
          ))]);
          this.TA_table.columns[9].filterOptions.filterDropdownItems = Array.from([...new Set(jobStatus.filter(
            function (el) {
              return el != null;
            }
          ))]);
          this.TA_table.columns[10].filterOptions.filterDropdownItems = Array.from([...new Set(stage.filter(
            function (el) {
              return el != null;
            }
          ))]);
        } else if (role === constants.NATA_ROLE_AR) {
          const jobType = this.AR_table.rows.map(i => i.type.value);
          const jobStatus = this.AR_table.rows.map(i => i.status.value);

          this.AR_table.columns[1].filterOptions.filterDropdownItems = Array.from([...new Set(jobType.filter(
            function (el) {
              return el != null;
            }
          ))]);
          this.AR_table.columns[2].filterOptions.filterDropdownItems = Array.from([...new Set(jobStatus.filter(
            function (el) {
              return el != null;
            }
          ))]);
        }
      }
    }
  }
</script>

